import { render, staticRenderFns } from "./paihangad.vue?vue&type=template&id=51142cfa&scoped=true"
import script from "./paihangad.vue?vue&type=script&lang=js"
export * from "./paihangad.vue?vue&type=script&lang=js"
import style0 from "./paihangad.vue?vue&type=style&index=0&id=51142cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51142cfa",
  null
  
)

export default component.exports